import { frontendURL } from '../../../helper/URLHelper';

const FunnelsIndex = () => import('./pages/FunnelsIndex.vue');
const FunnelBoard = () => import('./pages/FunnelBoard.vue');
const FunnelsDashboard = () => import('./pages/FunnelsDashboard.vue');
const TrafficSourceDashboard = () => import('./pages/TrafficSourceDashboard.vue');
const AgentDashboardPage = () => import('./pages/AgentDashboardPage.vue');

const commonMeta = {
  permissions: ['administrator', 'agent'],
};

export const routes = [
  {
    path: frontendURL('accounts/:accountId/funnels'),
    component: FunnelsIndex,
    meta: commonMeta,
    children: [
      {
        path: '',
        name: 'funnels_index',
        component: FunnelsIndex,
        meta: commonMeta,
      },
    ],
  },
  {
    path: frontendURL('accounts/:accountId/funnels/dashboard'),
    name: 'funnels_dashboard',
    component: FunnelsDashboard,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/funnels/agent-dashboard'),
    name: 'agent_dashboard',
    component: AgentDashboardPage,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/funnels/traffic-sources'),
    name: 'funnels_traffic_sources',
    component: TrafficSourceDashboard,
    meta: commonMeta,
  },
  {
    path: frontendURL('accounts/:accountId/funnels/:funnelId'),
    name: 'funnel_board',
    component: FunnelBoard,
    meta: commonMeta,
  },
];
